import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Accordion, Actionable, Icon, Text, View } from '@zinc/ui';
import type React from 'react';

export interface IProps extends React.PropsWithChildren {
  bodyStyle?: React.CSSProperties;
  expanded?: boolean;
  controlled?: boolean;
  forceExpand?: boolean;
  innerTitleStyle?: React.CSSProperties;
  style?: React.CSSProperties;
  title?: string;
  titleClass?: string;
  titleStyle?: React.CSSProperties;
  dataTestId?: string;
  onToggle?: (e: any, value: boolean) => void;
  backgroundColor?: string;
}

const ResponsivePanel: React.FC<IProps> = ({
  controlled = false,
  expanded = false,
  forceExpand = false,
  style = {},
  title = '',
  titleClass = '',
  titleStyle = {},
  onToggle,
  children,
  dataTestId,
  backgroundColor = 'white'
}) => {
  return (
    <View
      className="col-span-2 border border-t-[var(--rs-color-background-primary)] border-t-[3px] border-2 border-[var(--rs-color-background-primary-faded)] rounded-b-md w-full"
      borderRadius="small"
      padding={4}
      backgroundColor={backgroundColor}
    >
      <Accordion
        defaultActive={!controlled && (expanded || forceExpand)}
        onToggle={onToggle ? (active) => onToggle({}, active) : undefined}
      >
        <Accordion.Trigger>
          {(attributes, { active }) => (
            <Actionable attributes={attributes} fullWidth={true}>
              <View
                paddingBottom={4}
                paddingTop={2}
                data-testid={dataTestId}
                direction="row"
                justify="space-between"
                attributes={{
                  'data-testid': dataTestId
                }}
              >
                <Text weight="medium" color="neutral-faded" className="uppercase">
                  {title}
                </Text>
                <Icon
                  svg={
                    <ChevronDownIcon
                      className={`transition-transform ${active ? 'rotate-180' : 'rotate-0'}`}
                    />
                  }
                  size={6}
                />
              </View>
            </Actionable>
          )}
        </Accordion.Trigger>
        <Accordion.Content>
          <View paddingTop={0} paddingStart={4}>
            {children}
          </View>
        </Accordion.Content>
      </Accordion>
    </View>
  );
};

export default ResponsivePanel;
